import React, { TouchEventHandler } from 'react'

interface SwipeableProps {
  children: React.ReactNode
  onLeftSwipe?: () => void
  onRightSwipe?: () => void
}

const Swipeable = ({
  children,
  onLeftSwipe,
  onRightSwipe,
}: SwipeableProps): JSX.Element => {
  const [touchStart, setTouchStart] = React.useState<number | null>(null)
  const [touchEnd, setTouchEnd] = React.useState<number | null>(null)

  // The required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50

  const onTouchStart: TouchEventHandler<unknown> = (e) => {
    // Otherwise the swipe is fired even with usual touch events
    setTouchEnd(null)
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove: TouchEventHandler<unknown> = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const onTouchEnd = (): void => {
    if (!touchStart || !touchEnd) return
    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    if (isLeftSwipe && onLeftSwipe) return onLeftSwipe()
    const isRightSwipe = distance < -minSwipeDistance
    if (isRightSwipe && onRightSwipe) return onRightSwipe()
  }

  return (
    <>
      {React.Children.map(children, (child, index) => {
        const childProps = {
          onTouchStart,
          onTouchMove,
          onTouchEnd,
          key: index,
        }
        return React.cloneElement(child as React.ReactElement, childProps)
      })}
    </>
  )
}

export default Swipeable
